var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.drugs, function (drug, index) {
        return _c("div", { staticClass: "drug_block" }, [
          _c(
            "div",
            { staticClass: "drug_select_div" },
            [_c("drugSearch", { attrs: { drugSelected: _vm.drugs } })],
            1
          ),
        ])
      }),
      _vm._v("\n\n  " + _vm._s(_vm.drugs) + "\n"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }